import React from 'react';
import { useArticleView } from '../ArticleViewContext';
import ArticleViewBody, { TitleBlock } from './ArticleViewBody';
import BodyCompareDialog from './BodyCompareDialog';
import PublishedAlsoToMedias, { publishedAlsoTargetMedias } from './PublishedAlsoToMedias';

export default function ArticleViewContent() {
    const { article, editableFields, getTargetMediaLabel } = useArticleView();
    const [expandBodyOpen, setExpandBodyOpen] = React.useState(false);
    const originalArticleBody = article?.[editableFields.BODY] ?? '';
    const publishedAlsoMedias = React.useMemo(
        () => publishedAlsoTargetMedias(article),
        [article]
    );

    return (
        <>
            <ArticleViewBody onExpandBody={() => setExpandBodyOpen(true)} />
            {publishedAlsoMedias.length > 0 && (
                <PublishedAlsoToMedias
                    medias={publishedAlsoMedias}
                    getTargetMediaLabel={getTargetMediaLabel}
                    sx={{ mt: 2.5, pt: 2, borderTop: 1, borderColor: 'divider' }}
                />
            )}
            <BodyCompareDialog
                open={expandBodyOpen}
                onClose={() => setExpandBodyOpen(false)}
                originalBody={originalArticleBody}
            />
        </>
    );
}

export function ArticleViewMobileTitle() {
    const { article } = useArticleView();
    return (
        <>
            <TitleBlock />
        </>
    );
}
